// import { useTranslations } from 'next-intl'

const useT = (phrase) => {
    // return useTranslations(phrase)
    return phrase
}

export default useT